export default "/_next/static/images/e7ddca8301718fbd88becdabe2663d90.png";